export default "__VITE_ASSET__1cc9649b__"